/** Etiquetas y colores compartidos por la app del tecnico y el gestor. */

export const STATUS_LABELS = {
  pending: 'Pendiente',
  assigned: 'Asignada',
  in_progress: 'En curso',
  blocked: 'Bloqueada',
  done: 'Terminada',
  verified: 'Verificada',
  cancelled: 'Cancelada',
};

export const STATUS_COLORS = {
  pending: 'default',
  assigned: 'info',
  in_progress: 'primary',
  blocked: 'error',
  done: 'success',
  verified: 'success',
  cancelled: 'default',
};

export const PRIORITY_LABELS = {
  baja: 'Baja',
  normal: 'Normal',
  alta: 'Alta',
  urgente: 'Urgente',
};

export const TASK_TYPES = [
  'recepcion', 'montaje', 'conexionado', 'prueba', 'PEM', 'formacion', 'entrega', 'otros',
];

export const DISCIPLINES = [
  'mecanica', 'electrica', 'instrumentacion', 'piping', 'programacion', 'civil',
];
